import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Link from "@material-ui/core/Link";

import AdminHeader from "../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import { useStyles } from "../../../../Components/CSS/FormStyle.css";
import Axios from "axios";
import { url } from "../../../../Config/Config";
import { connect } from "react-redux";
import StudentMarksView from "./StudentMarksView/StudentMarksView";
import ExamFilterForm from "../ExamFilterForm/ExamFilterForm";
import { withRouter } from "react-router";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";
import CustomEmptyMessage from "../../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import PageTitle from "../../../../Components/PageTitle/PageTitle";
import CustomBreadCrumbs from "../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class MarksRegister extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        session: new Date().getFullYear().toString(),
        exam: "",
        section: "",
        class: "",
        faculty: "",
        group: "",
      },
      error: {
        batchError: "",
      },
      examList: [],
      classList: [],
      studentList: [],
      marksList: [],
      isEmpty: true,
      isExam: false,
      loading: false,
    };
  }

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    try {
      const examResponse = await Axios.get(`${url}/api/exam-types`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (examResponse.data.examTypes.length !== 0) {
        this.setState({
          examList: examResponse.data.examTypes,
        });
      }

      const classResponse = await Axios.get(`${url}/api/schoolclass`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (classResponse.data.classes.length !== 0) {
        this.setState({
          classList: classResponse.data.classes,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getData();
      }
    }
  };

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleChangeClass = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        class: e.target.value,
        section: "",
        faculty: "",
        group: "",
      },
    });
  };

  checkError = () => {
    let batchError = "";

    let sessionArr = this.state.data.session.toString().split("");
    if (sessionArr.length < 4) {
      batchError = "Please enter year in 4 digits";
    }

    if (batchError) {
      this.setState({
        error: {
          batchError,
        },
      });
      return false;
    } else {
      this.setState({
        error: {
          batchError: "",
        },
      });
      return true;
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.getExamination();
    try {
      this.setState({ loading: true });
      let studentList;
      const response = await Axios.get(`${url}/api/students`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.students.length !== 0) {
        if (this.state.data.faculty === "" && this.state.data.group === "") {
          studentList = response.data.students.filter((student) => {
            return (
              student.currentSession.indexOf(this.state.data.session) !== -1 &&
              student.studentClass.indexOf(this.state.data.class) !== -1 &&
              student.section.indexOf(this.state.data.section) !== -1
            );
          });
        } else {
          studentList = response.data.students.filter((student) => {
            return (
              student.currentSession.indexOf(this.state.data.session) !== -1 &&
              student.studentClass.indexOf(this.state.data.class) !== -1 &&
              student.faculty &&
              student.faculty.indexOf(this.state.data.faculty) !== -1 &&
              student.group &&
              student.group.indexOf(this.state.data.group) !== -1 &&
              student.section.indexOf(this.state.data.section) !== -1
            );
          });
        }
      }
      if (studentList.length !== 0) {
        this.setState({
          studentList,
          isEmpty: false,
          loading: false,
        });
      } else {
        this.setState({
          studentList: [],
          isEmpty: true,
          loading: false,
        });
      }
    } catch (error) {
      this.setState({ loading: true });
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleSubmit(e);
      }
    }
  };

  getExamination = async () => {
    try {
      const response = await Axios.get(`${url}/api/exams`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      let filterList = null;
      if (response.data.exams.length !== 0) {
        if (this.state.data.faculty === "" && this.state.data.group === "") {
          filterList = response.data.exams.filter((exam) => {
            return (
              exam.examType.indexOf(this.state.data.exam) !== -1 &&
              exam.session.indexOf(this.state.data.session) !== -1 &&
              exam.className.indexOf(this.state.data.class) !== -1 &&
              exam.section.indexOf(this.state.data.section) !== -1
            );
          });
        } else {
          filterList = response.data.exams.filter((exam) => {
            return (
              exam.examType.indexOf(this.state.data.exam) !== -1 &&
              exam.session.indexOf(this.state.data.session) !== -1 &&
              exam.className.indexOf(this.state.data.class) !== -1 &&
              exam.faculty.indexOf(this.state.data.faculty) !== -1 &&
              exam.group.indexOf(this.state.data.group) !== -1 &&
              exam.section.indexOf(this.state.data.section) !== -1
            );
          });
        }
      }

      if (filterList.length !== 0) {
        let subjectArr = [];
        for (let i = 0; i <= filterList[0].subjects.length - 1; i++) {
          subjectArr.push({
            subjectName: filterList[0].subjects[i].name,
            theory: 0,
            practical: 0,
            status: "",
          });
        }
        if (filterList.length !== 0) {
          this.setState({
            marksList: subjectArr,
            isExam: false,
          });
        }
      } else {
        this.setState({
          marksList: [],
          isExam: true,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getExamination();
      }
    }
  };

  render() {
    const { classes } = this.props;
    const subjectFilterClass = this.state.classList
      .filter((data) => data.className === this.state.data.class)
      .map((data) => data.subjects);
    const subjectFilter = this.state.classList
      .filter(
        (data) =>
          data.className === this.state.data.class &&
          data.faculty === this.state.data.faculty &&
          data.group === this.state.data.group
      )
      .map((data) => data.subjects);
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          {this.props.studentId ? (
            <PageTitle title="Edit Marks Grouping" />
          ) : (
            <PageTitle title="Register Marks" />
          )}

          <ExamFilterForm
            loading={this.state.loading}
            buttonLabel="Get Students"
            data={this.state.data}
            handleChangeClass={this.handleChangeClass}
            handleChange={this.handleChange}
            handleSubmit={this.handleSubmit}
          />
          <br />
          <Button
            variant="outlined"
            className={classes.buttonStyle}
            onClick={() =>
              this.props.history.push(`/administration/Marks-Publish`)
            }
          >
            Go To Publishing
          </Button>
          {this.state.marksList.length !== 0 ? (
            this.state.studentList.length !== 0 && (
              <StudentMarksView
                initialMarksList={this.state.marksList}
                students={this.state.studentList}
                search={this.state.search}
                examConfig={this.state.data}
                subjectFilterClass={subjectFilterClass}
                subjectFilter={subjectFilter}
              />
            )
          ) : this.state.isExam ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <p>The examination is not configured for this class</p>
              <Link href="/administration/examconfig">
                Go to Configure Exam
              </Link>
            </div>
          ) : (
            <CustomEmptyMessage description="Please Fill Above Form" />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    isAdmin: state.AdminReducer.isAdmin,
    role: state.AdminReducer.role,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(MarksRegister)));
